import React from 'react';
import styled from 'styled-components';

const spreadsheetData = [
  ['', 'A', 'B', 'C', 'D', 'E'],
  ['1', "Pemberton & Associates", '', 'ACCOUNTS 2024/25', '', ''],
  ['2', '', '', '', '', ''],
  ['3', 'Date', 'Description', 'Income', 'Expenses', 'Notes'],
  ['4', '06/04/24', 'Conveyancing - 12 Maple Drive', '£3,500', '', 'completion delayed twice'],
  ['5', '12/04/24', 'Westlaw subscription', '', '£480', 'do we still use this?'],
  ['6', '15/04/24', 'Litigation - Henderson v Clarke', '£8,200', '', 'client paying in instalments'],
  ['7', '22/04/24', 'Office rent - quarter 2', '', '£4,200', ''],
  ['8', '23/04/24', 'Photocopier lease', '', '£???', 'need to find the contract'],
  ['9', '01/05/24', 'PII renewal', '', '£probably about 6000', ''],
  ['10', '15/05/24', 'Family law - Daniels divorce', '£12,000', '', 'he still owes us £4,200'],
  ['11', '22/05/24', 'Stationery & headed paper', '', '£342.11', 'some was for Jenny\'s personal use'],
  ['12', '01/06/24', 'Lunch with David (barrister)', '', '£87.50', 'client entertaining??'],
  ['13', '15/06/24', 'SRA practising certificate', '', '£annual I think', ''],
  ['14', '20/06/24', 'Wills - Mrs Richardson', '£450', '', ''],
  ['15', '01/07/24', 'Phone system (Avaya)', '', '£182', 'use phones for work 100% surely?'],
  ['16', '15/07/24', 'Sage subscription', '', '£12/month', 'why do I pay for this'],
  ['17', '01/08/24', 'Various small matters', '£about 9k', '', 'need to check case files'],
  ['18', '15/08/24', 'New suits for partners x2', '', '£1,289', 'allowable expense?'],
  ['19', '01/09/24', 'Commercial property deal', '£45,000', '', 'invoiced but not paid yet'],
  ['20', '', '', '', '', ''],
  ['21', '', '', 'TOTAL', 'TOTAL', ''],
  ['22', '', '', '=SUM(dunno)', '=HELP', ''],
  ['23', '', '', '', '', ''],
  ['24', '', 'VAT', '', 'pretty sure we should be registered', ''],
  ['25', '', 'TAX RETURN', '', 'DUE 31 JAN - AAAARGH', ''],
  ['26', '', '', '', '', ''],
  ['27', '', 'NOTE TO SELF:', '', '', ''],
  ['28', '', 'Ring Dead Simple Accounting', '', '', ''],
  ['29', '', 'www.deadsimpleaccounting.co.uk', '', '', ''],
  ['30', '', 'Tax returns from £300!!!', '', '', ''],
];

export default function FakeExcel({ onClose }) {
  return (
    <Div>
      <section className="xl__toolbar">
        <div className="xl__menu">
          <span className="xl__menu__item" onClick={onClose}>File</span>
          <span className="xl__menu__item">Edit</span>
          <span className="xl__menu__item">View</span>
          <span className="xl__menu__item">Insert</span>
          <span className="xl__menu__item">Format</span>
          <span className="xl__menu__item">Tools</span>
          <span className="xl__menu__item">Data</span>
          <span className="xl__menu__item">Help</span>
        </div>
      </section>
      <section className="xl__formula_bar">
        <div className="xl__cell_ref">A1</div>
        <div className="xl__formula_sep">=</div>
        <div className="xl__formula_input">Pemberton & Associates</div>
      </section>
      <div className="xl__sheet">
        <table className="xl__table">
          <tbody>
            {spreadsheetData.map((row, rowIndex) => (
              <tr key={rowIndex} className={rowIndex === 0 ? 'xl__header_row' : ''}>
                {row.map((cell, colIndex) => {
                  if (rowIndex === 0 && colIndex === 0) {
                    return <th key={colIndex} className="xl__corner"></th>;
                  }
                  if (rowIndex === 0) {
                    return <th key={colIndex} className="xl__col_header">{cell}</th>;
                  }
                  if (colIndex === 0) {
                    return <td key={colIndex} className="xl__row_header">{cell}</td>;
                  }

                  const isError = cell.includes('dunno') || cell.includes('HELP') || cell.includes('???') || cell.includes('probably') || cell.includes('about');
                  const isImportant = cell.includes('AAAARGH') || cell.includes('Dead Simple');
                  const isLink = cell.includes('www.');

                  return (
                    <td
                      key={colIndex}
                      className={`xl__cell ${isError ? 'xl__cell--error' : ''} ${isImportant ? 'xl__cell--important' : ''} ${isLink ? 'xl__cell--link' : ''}`}
                      onClick={isLink ? () => window.open('https://www.deadsimpleaccounting.co.uk', '_blank') : undefined}
                    >
                      {cell}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="xl__sheets_bar">
        <div className="xl__sheet_tab xl__sheet_tab--active">Sheet1 (MAIN)</div>
        <div className="xl__sheet_tab">Sheet2 (TIMESHEETS - empty)</div>
        <div className="xl__sheet_tab">Sheet3 (VAT - TODO)</div>
      </div>
      <footer className="xl__statusbar">
        <span>Ready</span>
        <span className="xl__statusbar__right">Sum: ERROR</span>
      </footer>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #d4d0c8;
  font-family: Tahoma, sans-serif;
  font-size: 11px;
  overflow: hidden;

  .xl__toolbar {
    background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
    border-bottom: 1px solid #808080;
  }
  .xl__menu {
    display: flex;
    padding: 2px 0;
  }
  .xl__menu__item {
    padding: 2px 8px;
    cursor: default;
    &:hover {
      background: #316ac5;
      color: white;
    }
  }
  .xl__formula_bar {
    display: flex;
    background: white;
    border-bottom: 1px solid #808080;
    height: 20px;
    align-items: center;
  }
  .xl__cell_ref {
    width: 60px;
    border-right: 1px solid #808080;
    padding: 0 4px;
    font-size: 11px;
  }
  .xl__formula_sep {
    padding: 0 4px;
    border-right: 1px solid #808080;
    font-weight: bold;
  }
  .xl__formula_input {
    padding: 0 4px;
    flex: 1;
  }
  .xl__sheet {
    flex: 1;
    overflow: auto;
    background: white;
  }
  .xl__table {
    border-collapse: collapse;
    width: 100%;
    min-width: 600px;
  }
  .xl__corner {
    width: 30px;
    background: #d4d0c8;
    border: 1px solid #808080;
  }
  .xl__col_header {
    background: linear-gradient(to bottom, #f0f0ea, #d4d0c8);
    border: 1px solid #808080;
    padding: 1px 4px;
    font-weight: bold;
    text-align: center;
    min-width: 80px;
  }
  .xl__row_header {
    background: linear-gradient(to right, #f0f0ea, #d4d0c8);
    border: 1px solid #808080;
    padding: 1px 4px;
    font-weight: bold;
    text-align: center;
    width: 30px;
  }
  .xl__cell {
    border: 1px solid #c0c0c0;
    padding: 1px 4px;
    white-space: nowrap;
    height: 16px;
    vertical-align: top;
  }
  .xl__cell--error {
    background: #fff0f0;
    color: #cc0000;
    font-style: italic;
  }
  .xl__cell--important {
    background: #ffffcc;
    font-weight: bold;
    color: #cc0000;
  }
  .xl__cell--link {
    color: #0000ff;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: #551a8b;
    }
  }
  .xl__sheets_bar {
    display: flex;
    background: #d4d0c8;
    border-top: 1px solid #808080;
    padding: 2px 0;
  }
  .xl__sheet_tab {
    padding: 2px 12px;
    background: #d4d0c8;
    border: 1px solid #808080;
    margin-left: 2px;
    font-size: 10px;
    cursor: default;
  }
  .xl__sheet_tab--active {
    background: white;
    border-bottom: 1px solid white;
    font-weight: bold;
  }
  .xl__statusbar {
    display: flex;
    justify-content: space-between;
    padding: 2px 4px;
    background: #ece9d8;
    border-top: 1px solid white;
    font-size: 10px;
  }
  .xl__statusbar__right {
    color: #cc0000;
  }
`;
